import { render, staticRenderFns } from "./my-todo-task-pool.vue?vue&type=template&id=a559534e"
import script from "./my-todo-task-pool.vue?vue&type=script&lang=js"
export * from "./my-todo-task-pool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports